// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"available-lesson_textContainer__1bKPV","container":"available-lesson_container__SNs_w"};